import React, { useEffect, useState } from 'react';
import { Redirect, Route } from 'react-router-dom';
import { toast } from 'react-toastify';

import api from '~/services/api';
import DefaultLayout from '../pages/_layouts/default';

import { useAuth } from '../hooks';

const PrivateRoutes = ({ component: Component, level = 2, path, ...rest }) => {
  const {
    signOut,
    createChecklistFirstLogin,
    createLabourChecklistOnDay15,
    isLogged,
    isTokenExpired,
  } = useAuth();

  const [isPermitted, setIsPermitted] = useState(true);

  // Verificar se deve redirecionar para mobile ou desktop (reutilizado em vários pontos)
  const isMobileContext =
    window.location.hostname === 'testes.cartefacile.com' ||
    window.location.pathname === '/mobile-signin';

  useEffect(() => {
    async function loadRoles() {
      const response = await api.get('company-users/get/level');

      const userLevel = response.data;

      if (userLevel < level) {
        setIsPermitted(false);
      }
    }

    loadRoles();
  }, [level]);

  // Efeito não-condicional para reagir quando isPermitted mudar.
  useEffect(() => {
    if (!isPermitted) {
      toast.warn('Você não tem autorização para utilizar este recurso.', {
        position: toast.POSITION.BOTTOM_RIGHT,
      });

      try {
        signOut();
      } catch (err) {
        // ignorar erro de signOut aqui
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isPermitted]);

  if (isTokenExpired()) {
    signOut();
    // Após deslogar, redirecionar para a tela de login via React Router
    return <Redirect to={isMobileContext ? '/mobile-signin' : '/signin'} />;
  }

  if (!isLogged()) {
    // Salvar a rota atual para redirecionamento após login
    const currentPath = window.location.pathname;
    const currentSearch = window.location.search;
    const fullPath = currentPath + currentSearch;

    // Só salvar se não for uma rota de login
    if (!currentPath.includes('signin') && !currentPath.includes('portal')) {
      localStorage.setItem('@Diretiva:redirectAfterLogin', fullPath);
    }

    // Redirecionar usando o componente <Redirect> para manter a navegação do React Router
    return <Redirect to={isMobileContext ? '/mobile-signin' : '/signin'} />;
  }

  if (isLogged() && !level) {
    if (path === '/') {
      return (
        <Route
          {...rest}
          render={props => (
            <DefaultLayout>
              <Component
                {...props}
                createChecklistFirstLogin={createChecklistFirstLogin}
                createLabourChecklistOnDay15={createLabourChecklistOnDay15}
              />
            </DefaultLayout>
          )}
        />
      );
    }

    return (
      <Route
        {...rest}
        render={props => (
          <DefaultLayout>
            <Component {...props} />
          </DefaultLayout>
        )}
      />
    );
  }

  if (isPermitted) {
    return (
      <Route
        {...rest}
        render={props => (
          <DefaultLayout>
            <Component {...props} />
          </DefaultLayout>
        )}
      />
    );
  }

  return <Redirect to={isMobileContext ? '/mobile-signin' : '/signin'} />;
};

export default PrivateRoutes;
